import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { HelpGlossary } from '@model';
import * as fromHelpStore from '@appStore/help';
import { Store } from '@ngrx/store';
@Component({
    selector: 'app-help-glossary',
    templateUrl: './help-glossary.component.html',
    standalone: false
})
export class HelpGlossaryComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  glossaryData: HelpGlossary[];
  @Input()
  searchTerm: string = '';
  @Input()
  searchTag: string = '';

  glossarySorted: HelpGlossary[];
  glossaryDisplay: HelpGlossary[];
  isTagFiltered: boolean = false;

  constructor(private helpStore: Store<fromHelpStore.State>) {}

  ngOnInit() {
    this.initGlossary();
  }

  ngOnChanges() {
    this.initGlossary();
  }

  ngOnDestroy() {
    this.helpStore.dispatch(new fromHelpStore.HelpSetGlossarySearch(''));
    this.helpStore.dispatch(new fromHelpStore.HelpSetGlossaryTagSearch(''));
  }

  initGlossary() {
    if (!this.glossaryData) {
      return;
    }
    this.isTagFiltered = false;
    this.glossarySorted = [...this.glossaryData];
    this.sortGlossary();
    this.glossaryDisplay = [...this.glossarySorted];
    
    // Apply tag filter if search tags are provided
    if (this.searchTag && this.searchTag.trim().length > 0) {
      this.doTagSearch(this.searchTag);
    }
    // Apply search if search term is provided
    else if (this.searchTerm && this.searchTerm.trim().length > 0) {
      this.doSearch(this.searchTerm);
    }
  }

  sortGlossary() {
    this.glossarySorted.sort((a, b) => {
      return this.compare(a.term.toUpperCase(), b.term.toUpperCase(), true);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  doSearch(searchPhrase: string) {
    if (searchPhrase.trim().length === 0) {
      this.glossaryDisplay = [...this.glossarySorted];
      this.isTagFiltered = false;
      return;
    }

    const searchPhraseLower = searchPhrase.toLowerCase();
    this.glossaryDisplay = this.glossarySorted.filter(g => g.term.toLowerCase().indexOf(searchPhraseLower) !== -1);
    this.isTagFiltered = false;
  }

  doTagSearch(searchTag: string) {
    if (searchTag.trim().length === 0) {
      this.glossaryDisplay = [...this.glossarySorted];
      this.isTagFiltered = false;
      return;
    }

    const searchTagLower = searchTag.toLowerCase().trim();
    this.glossaryDisplay = this.glossarySorted.filter(g => {
      if (!g.tags) {
        return false;
      }
      // Split tags by comma and trim each tag
      const tags = g.tags.split(',').map(tag => tag.trim().toLowerCase());
      // Check for full match
      return tags.includes(searchTagLower);
    });
    this.isTagFiltered = true;
  }
}